import { useEffect, useEffectEvent, useRef } from "react";
import { useServiceBus } from "../../hooks/useServiceBus";
import { theme } from "../../layout/Theme";

export const AllAppointments = ({ calendarUrl }: { calendarUrl: string }) => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const serviceBus = useServiceBus();

  const authenticateIframe = useEffectEvent(() => {
    const iframe = iframeRef.current;
    if (iframe === null) return;

    serviceBus.dispatch({ type: "iframeAuthentication", iframe });
  });

  useEffect(() => {
    authenticateIframe();
  }, []);

  return (
    <iframe
      ref={iframeRef}
      id="appointments-iframe"
      src={`${calendarUrl}/appointments?primaryColor=${theme.palette.primary[500]?.replace("#", "%23")}`}
      width="100%"
      height="100%"
      style={{ border: 0, backgroundColor: "white", borderRadius: "8px", padding: "10px" }}
    />
  );
};
